"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../api");
var _effect = _interopRequireDefault(require("../effect.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ProjectEdit',
  mixins: [_effect.default],
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        projectNumber: '',
        applicationNumber: '',
        innerCompanyName: '',
        companyId: '',
        salesPrice: 0,
        id: null,
        reason: '',
        remark: '',
        innerRemark: '',
        sendType: ''
      },
      rules: {
        salesPrice: [{
          required: false,
          message: '请输入销售价',
          trigger: 'blur'
        }],
        sendType: [{
          required: true,
          message: '请选择发卡类型',
          trigger: 'blur'
        }]
      },
      cardTypeOptions: []
    };
  },
  methods: {
    open: function open(row) {
      this.dialogVisible = true;

      // 初始化表单数据
      this.form = {
        projectNumber: row.projectNumber || '',
        applicationNumber: row.applicationNumber || '',
        innerCompanyName: row.innerCompanyName || row.companyName || '',
        companyId: row.companyId === undefined || row.companyId === null ? '' : row.companyId,
        salesPrice: row.salesPrice !== undefined ? Number(row.salesPrice) : 0,
        id: row.id,
        reason: row.reason || '',
        remark: row.remark || '',
        innerRemark: row.innerRemark || '',
        sendType: row.sendType || ''
      };
      console.log('打开编辑对话框，初始化数据:', this.form);
    },
    close: function close() {
      this.dialogVisible = false;
      this.form = {
        projectNumber: '',
        applicationNumber: '',
        innerCompanyName: '',
        companyId: '',
        salesPrice: 0,
        id: null,
        reason: '',
        remark: '',
        innerRemark: '',
        sendType: ''
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.$refs.formRef.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
                  var data, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        if (valid) {
                          _context.n = 1;
                          break;
                        }
                        return _context.a(2);
                      case 1:
                        _this.loading = true;
                        _context.p = 2;
                        // 构建要提交的数据
                        data = {
                          id: _this.form.id,
                          projectNumber: _this.form.projectNumber || '',
                          applicationNumber: _this.form.applicationNumber || '',
                          innerCompanyName: _this.form.innerCompanyName || '',
                          companyId: _this.form.companyId === undefined || _this.form.companyId === null ? '' : _this.form.companyId,
                          salesPrice: _this.form.salesPrice || 0,
                          reason: _this.form.reason || '',
                          remark: _this.form.remark || '',
                          innerRemark: _this.form.innerRemark || '',
                          sendType: _this.form.sendType || ''
                        };
                        console.log('提交的项目信息数据:', data);

                        // 使用客户积分日志的update-basic接口
                        _context.n = 3;
                        return (0, _api.updateBasicInfoApi)(data);
                      case 3:
                        _this.$message.success('保存成功');
                        _this.dialogVisible = false;
                        _this.$emit('refresh');
                        _context.n = 5;
                        break;
                      case 4:
                        _context.p = 4;
                        _t = _context.v;
                        console.error('保存失败:', _t);
                        _this.$message.error('保存失败: ' + (_t.message || '未知错误'));
                      case 5:
                        _context.p = 5;
                        _this.loading = false;
                        return _context.f(5);
                      case 6:
                        return _context.a(2);
                    }
                  }, _callee, null, [[2, 4, 5, 6]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    handleCompanyChange: function handleCompanyChange(companyId) {
      var company = this.findCompany(companyId, this.companyOptions);
      this.form.innerCompanyName = company ? company.name : '';
    },
    findCompany: function findCompany(companyId, options) {
      if (companyId === '' || companyId === undefined || companyId === null) {
        return null;
      }
      return (options || []).find(function (item) {
        return String(item.id) === String(companyId);
      });
    }
  },
  props: {
    sendTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    companyOptions: function companyOptions() {
      var options = this.companyList || [];
      var hasSelectedCompany = !!this.findCompany(this.form.companyId, options);
      if (!this.form.companyId || hasSelectedCompany || !this.form.innerCompanyName) {
        return options;
      }
      return [].concat(_toConsumableArray(options), [{
        id: this.form.companyId,
        name: this.form.innerCompanyName
      }]);
    }
  },
  watch: {
    sendTypeList: {
      handler: function handler(val) {
        console.log('接收到发卡类型列表:', val);
        this.cardTypeOptions = val || [];
      },
      immediate: true
    }
  }
};